/**
 * Theme v3 in the admin (spec docs/superpowers/specs/2026-10-08-theme-v3-design.md Teil 2).
 * v3 keeps the settings of direct_top2 (same paths, same defaults). Its settings form is the
 * direct_top2 one without the parts v3 does not render: those fields would do nothing, so
 * hiding them is right here (memory "Einstellungen nicht wegfiltern" covers working fields).
 */
import { isPagesAsModel } from './catalogSwitch';

export const THEME_V3 = 'v3';

/** Theme of a new project: v3 for groups with "webmag Editor v3" on, else direct_top2. */
export function themeFuerNeuesProjekt(groupSettings) {
  return isPagesAsModel(groupSettings) ? THEME_V3 : 'direct_top2';
}

/** The global v3 row is listed only for v3 groups; a project already on v3 keeps seeing it. */
export function themeSichtbar(themeName, groupSettings, istAktuell = false) {
  return themeName !== THEME_V3 || istAktuell || isPagesAsModel(groupSettings);
}

/** Themes whose new projects take src/defaultData/themeSettingsDirectTop2.js, not themes.default_settings. */
export function nutztDirectTop2Startwerte(themeName) {
  return themeName === 'direct_top2' || themeName === THEME_V3;
}

// Spec "Nicht drin": not rendered by theme v3 (yet).
const OHNE_SEKTIONEN = ['menuButtons', 'navigationWidget'];
const OHNE_FELDER = {
  menu: ['pagination', 'menuTags'],
  sideMenu: ['showTaggedSubArticles'],
};

/** The direct_top2 form config (ThemeSettingsDirectTop2.vue themeFieldConfig) for a v3 project; never mutates. */
export function v3Sektionen(config) {
  return config
    .filter((sektion) => !OHNE_SEKTIONEN.includes(sektion.handle))
    .map((sektion) => {
      const ohne = OHNE_FELDER[sektion.handle] || [];
      return ohne.length ? { ...sektion, fields: sektion.fields.filter((feld) => !ohne.includes(feld.handle)) } : sektion;
    });
}
